import React from 'react';
import { Layout, Dropdown, Button, Space } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import ScientiaColors from '../styles/scientia-colors.json';
import HeaderButton from './HeaderButton';
import logo from '../images/EMSL_0541_BRAND_ScientiaLogo_FullLogo_ColorReversed.svg';
import white_emsl from '../images/White_EMS_ logo.svg';
import { OpenInNew } from './OpenInNew';
import './ScientiaHeader.less';
import type { MenuProps } from 'antd';
import { useState } from 'react';
import { MenuOutlined } from '@ant-design/icons';
import UserHeaderInfo from './access/UserHeaderInfo';
// import Circles from '../images/Circles-green.svg'
import InsightEngine from '../images/InsightEngine-green.svg';
import Lims from '../images/Lims-green.svg';
import ProposalSubmission from '../images/ProposalSubmission-green.svg';
import SageMaker from '../images/Amazon-SageMaker_Model_light-bg.svg';
import Search from '../images/search-green.svg';

interface Props  {
  currentUser: any;
  logoutHandler: any;
  handleMenuToggle: () => void;
  onExternalLinkClick: (url: string) => void;
};

const ScientiaHeader: React.FC<Props> = ({currentUser, logoutHandler, handleMenuToggle, onExternalLinkClick}) => {
  
  const [isHovered, setHovered] = useState(false);

  const contentStyle = {
    color: 'blue',
  }

  const homeButtonStyles = {
    color: ScientiaColors['scientia-blue'],
    border: 'none',
    transition: 'color 0.2s',
  }

  const buttonStyles = {
    color: ScientiaColors['scientia-blue'],
    border: 'none',
    transition: 'color 0.2s',
  }

  const { Header } = Layout;

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    console.log('click', e);
  }

  const handleExternalLinkClick = (url: string, e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onExternalLinkClick(url);
  };

  const handleProposalClick = (e: any) => {
    handleExternalLinkClick(process.env.REACT_APP_PROPOSAL_MANAGEMENT as string, e);
  }

  const handleLIMSClick = (e: any) => {
    handleExternalLinkClick('LIMS_CARDS', e);
  }

  const handleDataPortalClick = (e: any) => {
    handleExternalLinkClick(process.env.REACT_APP_DATA as string, e);
  }
 
  const handleWorkBenchClick = (e: any) => {
    handleExternalLinkClick('MODELING_WORKBENCH_CARDS', e);
  }  
  const handleInsightClick = (e: any) => {
    handleExternalLinkClick('INSIGHT_ENGINE_CARDS', e);
  }

  const hamburgerItems = [
    {
      label: (
        <div className="dropdown">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={process.env.REACT_APP_EMSL_PROPOSAL_CALLS}
            style={{
              color: ScientiaColors['scientia-blue'],
              fontFamily: 'Open Sans',
              fontSize: '16px',
              flex:1,
            }}
          >
            Proposal Calls
          </a>
        </div>
      ),
      key: '1',
    },
    {
      label: (
        <div className="dropdown">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={process.env.REACT_APP_EMSL_LEARNING}
            style={{
              color: ScientiaColors['scientia-blue'],
              fontFamily: 'Open Sans',
              fontSize: '16px',
              flex:1,
            }}
          >
            EMSL LEARN
          </a>
        </div>
      ),
      key: '2',
    },
  ]

  const items: MenuProps['items'] = [
    {
      label: (
        <div className="dropdown">
          <img src={ProposalSubmission} height="100%" alt="scientia-portal" />
          <span
            onClick={handleProposalClick}
            style={{
              marginLeft: '8px',
              color: ScientiaColors['scientia-blue'],
              fontFamily: 'Open Sans',
              fontSize: '16px',
            }}
          >
            Proposal Management
          </span>
        </div>
      ),
      key: '1',
    },
    {
      label: (
        <div className="dropdown">
          <img src={Lims} height="100%" alt="scientia-lims" />
          <span
            onClick={handleLIMSClick}
            style={{
              marginLeft: '8px',
              color: ScientiaColors['scientia-blue'],
              fontFamily: 'Open Sans',
              fontSize: '16px',
              flex:1,
            }}
          >
            LIMS
          </span>
        </div>
      ),
      key: '2',
    },
    {
      label: (
        <div className="dropdown">
          <img src={Search} height="100%" alt="scientia-Engine" />
          <span
            onClick={handleDataPortalClick}
            style={{
              marginLeft: '8px',
              color: ScientiaColors['scientia-blue'],
              fontFamily: 'Open Sans',
              fontSize: '16px',
              flex:1,
            }}
          >
            Data
          </span>
        </div>
      ),
      key: '3',
    }, 
    {
      label: (
        <div className="dropdown">
          <img src={SageMaker} height="100%" alt="scientia-sagemeker" />
          <span
            onClick={handleWorkBenchClick}
            style={{
              marginLeft: '8px',
              color: ScientiaColors['scientia-blue'],
              fontFamily: 'Open Sans',
              fontSize: '16px',
              flex:1,
            }}
          >
            Modeling Workbench
          </span>
        </div>
      ),
      key: '4',
    },
    {
      label: (
        <div className="dropdown">
          <img src={InsightEngine} height="100%" alt="scientia-insight-engine" />
          <span
            onClick={handleInsightClick}
            style={{
              marginLeft: '8px',
              color: ScientiaColors['scientia-blue'],
              fontFamily: 'Open Sans',
              fontSize: '16px',
              flex:1,
            }}
          >
            Insight Engine
          </span>
        </div>
      ),
      key: '5',
    },
    // {
    //   label: (
    //     <div className="dropdown">
    //       <img src={Circles} height="100%" alt="scientia-image" />
    //       <a
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         href="/"
    //         style={{
    //           marginLeft: '8px',
    //           color: ScientiaColors['scientia-light-green'],
    //           fontFamily: 'Open Sans',
    //           fontSize: '16px',
    //         }}
    //       >
    //         Circles
    //       </a>
    //     </div>
    //   ),
    //   key: '6',
    // },
  ]

  const menuProps = {
    items,
    onClick: handleMenuClick,
  }

  const customStyles = {
    backgroundColor: ScientiaColors['scientia-grey'],
    fontSize: '16px',
    color: ScientiaColors['scientia-blue'],
  }

  return (
    <Header className="Header">
      <nav className="nav">

        <a href="https://www.emsl.pnnl.gov/" target="_blank" rel="noopener noreferrer">
          <img className="logo-emsl"  src={white_emsl} alt = "logo" />
        </a>
        <p className="separator-bar">|</p>
        <img className="logo" src={logo} alt="logo" />
        <Dropdown
          menu={menuProps}
          overlayStyle={{ color: ScientiaColors['scientia-blue'] }}
          dropdownRender={(menu) => (
            <div style={contentStyle}>
              {React.cloneElement(menu as React.ReactElement, {
                style: customStyles,
              })}
            </div>
          )}
        >
          <span onClick={(e) => e.preventDefault()} className="hover-me-link">
            <Button
              className="button header-button"
              style={homeButtonStyles}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >
              <Space>
                Science Central™
                <CaretDownOutlined style={{ fontSize: '12px' }} />
              </Space>
            </Button>
          </span>
        </Dropdown>
        <HeaderButton
          className="button header-button"
          label="Proposal Calls"
          styles={buttonStyles}
          path={process.env.REACT_APP_EMSL_PROPOSAL_CALLS}
        >
          <OpenInNew
            className="open-in-new"
            color={ScientiaColors['scientia-blue']}
          />
        </HeaderButton>
        <HeaderButton
          className="button header-button"
          label="EMSL LEARN"
          styles={buttonStyles}
          path={process.env.REACT_APP_EMSL_LEARNING}
        >
          <OpenInNew
            className="open-in-new"
            color={ScientiaColors['scientia-blue']}
          />
        </HeaderButton>
      </nav>

      <div className="button-group">
        <UserHeaderInfo
          userInfo={currentUser}
          logoutHandler={logoutHandler}
          handleMenuToggle={handleMenuToggle}
          menuPropsScienceCentral = {menuProps}
          hamburgerItemsExternal = {hamburgerItems}
        />
      </div>
    </Header>
  )
}

export default ScientiaHeader
